import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const tomos = [{
  num: '1',
  title: 'El Diccionario Visual',
  subtitle: '100 pictogramas por categorías: el vocabulario visual completo de tu hijo.'
}, {
  num: '2',
  title: 'Rutinas de Autonomía',
  subtitle: 'Agendas visuales para mañana, baño, comida, escuela y noche. Adiós a las batallas.'
}, {
  num: '3',
  title: 'Control de la Ansiedad',
  subtitle: 'Semáforo Emocional, Rincón de Calma y anticipación para que sepa cómo se siente.'
}, {
  num: '4',
  title: 'Historias Sociales',
  subtitle: 'Médico, súper, cumpleaños y transporte: el mundo exterior deja de dar miedo.'
}, {
  num: '5',
  title: 'Juego y Estimulación',
  subtitle: '30 actividades terapéuticas en casa para estimular la comunicación y el vínculo.'
}];
const includes = ['Pictogramas y fichas imprimibles', 'Actividades progresivas', 'Plantillas listas para usar', 'Guías paso a paso para padres', 'Protocolos de uso en casa y escuela'];
export function WhatsIncluded() {
  return <section className="py-12 md:py-16 bg-cream" data-id="element-318">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-319">
        <div className="text-center mb-8" data-id="element-320">
          <div className="inline-flex items-center justify-center space-x-2 bg-amber-100 text-amber-700 px-4 py-1.5 rounded-full font-bold text-sm mb-4" data-id="element-321">
            <span data-id="element-322">🏆 COLECCIÓN DIGITAL</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-teal-900" data-id="element-323">
            MÉTODO CONECTA-TEA
          </h2>
          <p className="text-lg text-stone-600 font-medium" data-id="element-324">
            5 Tomos + 5 Bonos — Desde los primeros pictogramas hasta la
            autonomía completa.
          </p>
          <p className="text-stone-500 text-sm mt-1" data-id="element-325">
            Todo organizado, secuenciado y listo para imprimir.
          </p>
        </div>

        <div className="space-y-4 mb-10" data-id="element-326">
          {tomos.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-xl p-5 shadow-sm border border-stone-100 flex items-start gap-4" data-id="element-327">
              <div className="w-12 h-12 flex-shrink-0 bg-teal-700 text-white rounded-lg flex flex-col items-center justify-center font-bold mt-1" data-id="element-328">
                <span className="text-[10px] opacity-70 leading-none mb-0.5" data-id="element-329">
                  TOMO
                </span>
                <span className="text-xl leading-none" data-id="element-330">{t.num}</span>
              </div>
              <div data-id="element-331">
                <h3 className="font-bold text-teal-900 text-lg mb-1" data-id="element-332">
                  {t.title}
                </h3>
                <p className="text-sm text-stone-600 leading-relaxed" data-id="element-333">
                  {t.subtitle}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="bg-white rounded-xl p-6 border border-stone-200 shadow-sm" data-id="element-334">
          <h4 className="font-bold text-teal-900 mb-4" data-id="element-335">Cada tomo incluye:</h4>
          <ul className="grid sm:grid-cols-2 gap-3" data-id="element-336">
            {includes.map((item, i) => <li key={i} className="flex items-start text-sm text-stone-700" data-id="element-337">
                <CheckCircle2 className="w-4 h-4 text-teal-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-338" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}